import App from "./journal/App.svelte"

let journalApp

const mount = () => {
  destroy()

  const root = document.querySelector("#journal-app")

  if (root === null) return

  const initialData = JSON.parse(root.dataset.initialData)

  journalApp = new App({
    target: root,
    props: {
      initialData
    }
  })
}

const destroy = () => {
  if (journalApp) {
    journalApp.$destroy()
    journalApp = null
  }
}

document.addEventListener("turbo:load", mount)
document.addEventListener("turbo:before-cache", destroy)
